import React, { useEffect, useRef, useState } from 'react'
import {
  Input,
  message,
  Col,
  Row,
  ConfigProvider,
  Popconfirm,
  Upload,
  Modal,
  Popover,
} from 'antd'
import { sendHttpPostRequest } from '../../../api/http-request'
import courseMainStyles from '../course-main.module.less'
import '../course.module.css'
import zhCN from 'antd/lib/locale/zh_CN'
import * as constants from '../../../constants/constants'
import kejianEmpty from '../../../static/image/empty/queshengye-kejian.png'
import formatIcon from '../../../static/image/formatIcon.png'

import slidesStyles from './course-main-teacher-slides.module.less'
import Cookies from 'js-cookie'
import courseCreateStyles from '../course-create.module.less'
import Draggable from 'react-draggable'



import Icon from '@ant-design/icons'


import  {ReactComponent as filepdfSvg }   from '../../../static/image/course/pdf.svg'
import { ReactComponent as filepptSvg }   from '../../../static/image/course/ppt.svg'
import { ReactComponent as filewordSvg }   from '../../../static/image/course/word.svg'
import { ReactComponent as fileexcelSvg }   from '../../../static/image/course/excel.svg'
import { ReactComponent as filecsvSvg }   from '../../../static/image/course/csv.svg'
import { ReactComponent as fileotherSvg }   from '../../../static/image/course/otherfile.svg'

import  {ReactComponent as mydeleteSvg }   from '../../../static/image/course/mydelete.svg'
const mydeleteIcon = (props:any) => (<Icon component={mydeleteSvg} {...props} />)

import  {ReactComponent as downloadSvg }   from '../../../static/image/course/download.svg'
const downloadIcon = (props:any) => (<Icon component={downloadSvg} {...props} />)

import { ReactComponent as eyeSvg }   from '../../../static/image/module/eye.svg'
const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)

import  {ReactComponent as closeeyeSvg }   from '../../../static/image/course/closeeye.svg'
const closeeyeIcon = (props:any) => (<Icon component={closeeyeSvg} {...props} />)


import  {ReactComponent as uploadSvg }   from '../../../static/image/course/upload.svg'
const uploadIcon = (props:any) => (<Icon component={uploadSvg} {...props} />)



const filepdfIcon = (props:any) => (<Icon component={filepdfSvg} {...props} />)
const filepptIcon = (props:any) => (<Icon component={filepptSvg} {...props} />)
const filewordIcon = (props:any) => (<Icon component={filewordSvg} {...props} />)
const fileexcelIcon = (props:any) => (<Icon component={fileexcelSvg} {...props} />)
const filecsvIcon = (props:any) => (<Icon component={filecsvSvg} {...props} />)
const fileotherIcon = (props:any) => (<Icon component={fileotherSvg} {...props} />)



export interface Props {
  course_id: any
  is_course_teacher: any
  course?: any
}


/** 教师课程主页面 */
export const CourseMainTeacherSlides: React.FC<Props> = (props) => {
  const { course_id, is_course_teacher, course } = props
  const [slides, setSlides] = useState([] as any[]) //课程的课件

  const selectedSlideId = React.useRef(null as any) //当前操作的课件
  const changedSlideName = React.useRef(null as any) //当前操作的课件名
  const [isChangeSlideNameModalVisible, setIsChangeSlideNameModalVisible] =
    useState(false) //修改课件名弹出框
  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  const getBackgroundByFileName = (filename:any)=> {
    let suffix = filename.toLowerCase()
    if (suffix.endsWith("ppt") || suffix.endsWith("pptx") ) {
        return "#f57c001a"
    }else if (suffix.endsWith("pdf")){
        return "#d32f2f1a"
    }else if (suffix.endsWith("xls") || suffix.endsWith("xlsx")) {
        return "#388e3c1a"
    }else if (suffix.endsWith("doc") || suffix.endsWith("docx")) {
        return "#1976d21a"
    }else if (suffix.endsWith("csv")) {
        return "#00796b1a"
    }else {
        return "#37474f1a"
    }
      
  }

  const getIconByFileName = (filename:any)=> {
    let suffix = filename.toLowerCase()
    if (suffix.endsWith("ppt") || suffix.endsWith("pptx") ) {
        return filepptIcon
    }else if (suffix.endsWith("pdf")){
        return filepdfIcon
    }else if (suffix.endsWith("xls") || suffix.endsWith("xlsx")) {
        return fileexcelIcon
    }else if (suffix.endsWith("doc") || suffix.endsWith("docx")) {
        return filewordIcon
    }else if (suffix.endsWith("csv")) {
        return filecsvIcon
    }else {
        return fileotherIcon
    }
      
  }


  const querySlides = () => {
    sendHttpPostRequest(
      'course/api/user_query_course_info',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
        } else if (response.is_ok) {
          setSlides(response.query_info.lecture_list)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  /**
   * 保存课程回调
   * @param response
   */
  const saveCourseInfoCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=course';
    } else if (response.code == -501) {
      // 没权限
      message.error('权限不足')
      // window.location.href = '/login?next=course';
    } else if (response.is_ok == true) {
      //message.success("课程信息保存成功~")
    } else {
      message.error(response.message)
    }
  }

  const saveCourse = (newSlides: any) => {
    sendHttpPostRequest(
      'course/api/user_update_course',
      {
        name: course?.name,
        course_id: course_id,
        lecture_list: JSON.stringify(newSlides),
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      saveCourseInfoCallback
    )
  }

  // 上传课件传参
  const uploadLectureData = {
    sessionid: Cookies.get('sessionid'),
    sid: Cookies.get('sessionid'),
    course_id: course_id,
  }

  // 上传课件
  const uploadLectureProps = {
    accept: '.ppt,.pptx,.pdf,.doc,.docx,.zip',
    name: 'data_file',
    multiple: false,
    showUploadList: true,
    data: uploadLectureData,
    action: constants.BACKEND_API_URL + 'course/api/course_upload_lecture/',
    onChange(info) {
      const { status } = info.file
      if (status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (status === 'done') {
        message.destroy()
        if (info.file.response.is_ok) {
          message.success(`文件${info.file.name}上传成功！`)
          const newLectureList = [...slides]
          newLectureList.push({
            id: info.file.response.id,
            name: info.file.response.url.split('/')[
              info.file.response.url.split('/').length - 1
            ],
            url: info.file.response.url,
            open: 0,
          })
          console.log(newLectureList)
          setSlides(newLectureList)
          saveCourse(newLectureList)
        } else {
          if (info.file.response.code == -100) {
            // 未登录
            // const localPath = window.location.href.split(window.location.host)[1];
            sessionStorage.setItem("previousurl",window.location.href )
            document.getElementById('show-login-modal')!.click()
            // window.location.href = `/login?next=course`;
          } else if (info.file.response.code == -501) {
            // 权限不足
            message.error('权限不足')
            // const localPath = window.location.href.split(window.location.host)[1];
            // window.location.href = `/login?next=course`;
          } else {
            message.error(info.file.response.message)
          }
        }
      } else if (status === 'error') {
        message.error(`文件${info.file.name}上传失败了:(`)
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
  }

  // 点击下载
  const onDownloadSlidesClick = (url: any, event: any) => {
    event.preventDefault()
    window.open(url?.startsWith('http') ? url : constants.BACKEND_URL + url)
  }

  /** 修改了课件名 */
  const onSlideNameChange = (e: any) => {
    changedSlideName.current = e.target.value
  }
  const handleChangeSlideNameOk = () => {
    //确认修改了课件名
    setIsChangeSlideNameModalVisible(false)
    const newLectureList = [...slides]
    newLectureList.map((item) => {
      if (item.id == selectedSlideId.current) {
        item.name = changedSlideName.current
      }
    })
    //console.log(newLectureList)
    setSlides(newLectureList)
    saveCourse(newLectureList)
  }

  // 点击开关
  const onSwitchClick = (slidesId: number, openStatus: number) => {
    const newLectureList = [...slides]
    newLectureList.map((item) => {
      if (item.id == slidesId) {
        item.open = openStatus == 0 ? 1 : 0
      }
    })
    setSlides(newLectureList)
    saveCourse(newLectureList)
  }

  const onDeleteClick = (slidesId: number) => {
    // console.log(slidesId)
    const newLectureList = slides.filter((item) => item.id !== slidesId)
    setSlides(newLectureList)
    deleteSlides(slidesId)
  }

  const deleteSlides = (slidesId: any) => {
    sendHttpPostRequest(
      'course/api/user_delete_course_lecture',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        lecture_id: slidesId,
        course_id: course_id,
      },
      (response: any) => {
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          //window.location.href = '/login?next=course-main-teacher?course_id=' + course_id;
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
          // window.location.href = '/login?next=course';
        } else if (response.is_ok == true) {
          message.success('课件删除成功~')
        } else {
          message.error(response.message)
        }
      }
    )
  }


  useEffect(() => {
    querySlides()
  }, [])

  return (
    <div >

      <Row wrap={false} align={"middle"} style={{margin: '0 0 24px'}}>
          <Col span={12} style={{textAlign:'left'}}>
              <div className={courseMainStyles.courseTabContentTitle}>课件管理</div>
          </Col>

          <Col span={12} style={{textAlign:'right'}}>
            <div >


              <Popover
                overlayStyle={{ marginTop: -5 }}
                content={
                  <div>
                    请选择pptx， pdf，docx格式文件,大小不超过50M。
                  </div>
                }
                placement="bottom"
                title={''}
                trigger="hover"
              >
                <span style={{ cursor: 'pointer', marginRight: 8, fontSize: 12 }}>
                  <img
                    src={formatIcon}
                    style={{ width: 16, height: 16, marginTop: -2 }}
                    alt=""
                  />
                  文件格式
                </span>
              </Popover>
              {is_course_teacher && (
                <Upload {...uploadLectureProps} className={slidesStyles.uploadWrapper}>
                  <span
                    style={{fontSize:14, padding:'4px 12px'}}
                    className={courseMainStyles.BtnDark}
                  >
                    <Icon component={uploadIcon}/> 上传课件
                  </span>
                </Upload>
              )}
    
            </div>
          </Col>
      </Row>

      <Row align={"middle"} gutter={[24,24]}>
        {
          slides?.map((slide, slideIndex)=>(
            <Col span={8} key={slideIndex}>
              <div className={slidesStyles.slideCard}>
                  <Row wrap={false} align="middle" style={{padding: 16}}>
                    <Col flex="60px">
                      <div>
                        <span className={slidesStyles.fileIconWrapper} style={{background:getBackgroundByFileName(slide?.name)}}>
                          <Icon component={getIconByFileName(slide?.name)}/>
                        </span>

                      </div>
                    </Col>

                    <Col flex="auto">
                      <div className={slidesStyles.slideName}>
                        {slide?.name}
                      </div>
                    </Col>
                  </Row>

                  <Row wrap={false} align="middle" className={slidesStyles.actionDiv}>
                    <Col span={12} style={{textAlign:'left'}}>
                      <div>
                        <span className={slidesStyles.openLabel}
                         style={{color: slide?.open == 0 ? "#4b5563":"#07c160", background: slide?.open == 0 ? "#4b55631a":"#07c1601a" }}>
                        {slide?.open == 0? '未开放':'已开放'}
                        </span>
                        </div>
                    </Col>
                    <Col span={12} style={{textAlign:'right'}}>
                      <div>
                          <span title="下载" className={slidesStyles.actionIconWrapper}
                          
                          onClick={onDownloadSlidesClick.bind(this, slide?.url)}
                           
                          ><Icon component={downloadIcon}/></span>  
                          <Popconfirm
                            placement="top"
                            title={'确认删除课件"' + slide?.name + '"吗？'}
                            onConfirm={onDeleteClick.bind(this, slide?.id)}
                            okText="确认"
                            cancelText="取消"
                          >
                            <span title="删除" className={slidesStyles.deleteIconWrapper} ><Icon component={mydeleteIcon}/></span> 
                          </Popconfirm>
                          


                          <span title={slide?.open == 0 ?"设置为开放":"设置为不开放"} 
                           onClick={onSwitchClick.bind(this, slide?.id, slide?.open)}
                          className={slidesStyles.actionIconWrapper} 
                          ><Icon component={slide?.open == 0 ? eyeIcon : closeeyeIcon}/></span>
                      </div>
                    </Col>
                  </Row>

              </div>
            </Col>
          ))
        }

      </Row>

        {slides.length == 0 && (
          <div style={{ textAlign: 'center', paddingTop: 20 }}>
            <img src={kejianEmpty} width={120} height={120} />
            <div style={{ color: '#999', marginTop: 10 }}>
              您还没添加课件~
            </div>
          </div>
        )}


      <ConfigProvider locale={zhCN}>
        <Modal
          title={
            <div
              style={{
                width: '100%',
                cursor: 'move',
              }}
              onMouseOver={() => {
                if (disabled) {
                  setDisabled(false)
                }
              }}
              onMouseOut={() => {
                setDisabled(true)
              }}
              onFocus={() => {}}
              onBlur={() => {}}
              // end
            >
              修改课件名称
            </div>
          }
          open={isChangeSlideNameModalVisible}
          onOk={handleChangeSlideNameOk}
          onCancel={() => {
            setIsChangeSlideNameModalVisible(false)
          }}
          bodyStyle={{ height: '120px' }}
          destroyOnClose={true}
          width={350}
          modalRender={(modal) => (
            <div className={courseCreateStyles.miniModal}>
              <Draggable
                disabled={disabled}
                bounds={bounds}
                onStart={(event, uiData) => onStart(event, uiData)}
              >
                <div ref={draggleRef}>{modal}</div>
              </Draggable>{' '}
            </div>
          )}
        >
          <Input
            defaultValue={changedSlideName.current}
            onChange={onSlideNameChange}
          ></Input>
        </Modal>
      </ConfigProvider>
    </div>
  )
}

export default CourseMainTeacherSlides
